module.exports = __webpack_public_path__ + "img/unsplash-logo.a90e0458.png";